<template>
    <div class="NotFoundDiv">
        <h2>404</h2>
        <h3>Page not found</h3>
    </div>
</template>

<script>
    export default {};
</script>

<style>
    .NotFoundDiv {
        padding: 150px 0 0 0;
        width: 200px;
        margin: auto;
        text-align: center;
    }
</style>
